export const cols = ["Atelier", "Lieu", "Date", "Capacité", "Filtres", "Disponible"]
export const colsOptions = [null, null, null, { align: "right" }, { align: "center" }, { align: "center" }]
